// CommentFooter.jsx

import React, { useMemo } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';
import { useUser } from 'context/UserContext';

// Utilities
import { canUser, PermissionAction } from 'utilities/Permissions';

// CSS
import './CommentFooter.css';

/**
 * CommentFooter component
 *
 * Reply affordance under a comment body.
 *
 * @returns {ReactNode} The rendered component.
 */
const CommentFooter = ({
    node,
    comment,
    onReplyClicked,
}) => {

    // ----- CONTEXT ----- //

    const { user } = useUser();
    const { theme } = useTheme();

    // ----- MEMOS ----- //

    const canComment = useMemo(() => {
        if (!node || !user) return false;
        return canUser(PermissionAction.COMMENT, node, user);
    }, [node, user]);

    if (!user || !comment || comment.deleted || !canComment) return null;

    // ----- RENDER ----- //

    return (
        <div className="comment-footer-left">
            <div
              className="comment-show-reply-button"
              style={{
                color: theme.foregroundMuted,
              }}
              onClick={(e) => onReplyClicked(e, comment)}
            >
                Reply
            </div>
        </div>
    );
};

// Dev Tools
CommentFooter.displayName = 'CommentFooter';

export default CommentFooter;
